/**
 * @file
 * Mobile menu scripts.
 */

const $button = $('#mobile-menu-button', context);
const $body = $('body', context);
// Context removed intentionally
const $mobileMenu = $('.cpl-mobile-menu');

function openPopup($el) {
  $el.addClass('is-active');
  setTimeout(() => {
    $body.addClass('is-fixed');
  }, 400);
}

function closePopup($el) {
  $el.addClass('is-closing');
  $body.removeClass('is-fixed');
  setTimeout(() => {
    $el.removeClass('is-closing is-active');
  }, 500);
}

// Open mobile menu.
$button.once('mobile-menu-open').each((index, el) => {
  $(el).click(event => {
    event.preventDefault();
    openPopup($('.cpl-mobile-menu'));
  });
});

// Menu popup scripts.
$mobileMenu.once('mobile-menu-popup').each((index, el) => {
  const $this = $(el);

  // Close mobile menu.
  $this.find('.close-button').click(event => {
    event.preventDefault();
    closePopup($this);
  });

  document.onkeydown = event => {
    event = event || window.event;
    if ($this.hasClass('is-active') && event.keyCode === 27) {
      closePopup($this);
    }
  };

  // Menus behavior.
  $this.find('.menu:not(.submenu) > li:last-child').addClass('bordered');

  $this
    .find('.menu:not(.submenu)')
    .children()
    .clone(true, true)
    .appendTo('.menu-combined');
  $this.find('.mobile-menu > ul').remove();

  const isMobile = () => {
    if (
      typeof Foundation !== 'undefined' &&
      Foundation.MediaQuery.current === 'small'
    ) {
      return true;
    }
  };

  // Mobile menu type 1
  if ($mobileMenu.hasClass('cpl-menu-type-1')) {
    // Drilldown menu
    $this
      .find('.is-dropdown-submenu-parent')
      .removeClass('is-dropdown-submenu-parent opens-right');

    $this
      .find('.submenu.menu')
      .removeClass('is-dropdown-submenu')
      .addClass('vertical nested');

    new Foundation.Drilldown($this.find('.drilldown'));
  } else if ($mobileMenu.hasClass('cpl-menu-type-4')) {
    // Mobile menu type 4
    $this.find('.menu > li > a').each((i, e) => {
      $(e).wrapInner('<span class="menu-item-text"></div>');
    });

    $body.addClass('is-vertical-menu');

    $this.find('.dropdown').on('show.zf.dropdownmenu', () => {
      $this.addClass('is-open');
      $('body').addClass('menu-opened');
      if (isMobile()) {
        $('body').addClass('is-fixed');
      }
    });

    $this.find('.dropdown').on('hide.zf.dropdownmenu', () => {
      $this.removeClass('is-open');
      $('body').removeClass('menu-opened');
      if (isMobile()) {
        $('body').removeClass('is-fixed');
      }
    });

    new Foundation.DropdownMenu($this.find('.dropdown'));

    // Open main menu on small screen
    const $logoMenu = $this.find('.menu-logo > a');
    $logoMenu.click(event => {
      if (Foundation.MediaQuery.current === 'small') {
        event.preventDefault();
        $this.toggleClass('logo-menu-opened');
      }
    });
  } else {
    // Accordion menu
    new Foundation.AccordionMenu($this.find('.accordion-menu'));
  }
});
